import type { ReactNode } from 'react';

export const symbol_washoku: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M324-120q-19.5 0-35.25-11.18T267-161l-48-146q-36.74-19.69-62.26-52.17Q131.23-391.66 120-433L94-537q-5-21 8.57-38.5T138-593h684q21.86 0 35.43 17.5T866-537l-26 104q-11 41.22-36 73.61T742-307l-49 146q-6 18-21.75 29.5T636-120H324Zm0-60h312l36-106H289l35 106Zm-14-165h340q47 0 83.5-28.5T782-448l22-85H157l21 85q11 46 47.53 74.5T310-345Zm491-248h-60v-62.5q0-26.25-17.79-44.38Q705.42-718 680-718q-17 0-32 8.5T623-684H521l-10-37q-8-27-27-43t-45-16q-22 0-40.5 12T371-736l-17 38h-81q-22 0-37.5 15.5T220-644.93V-593h-60v-52q0-47.08 30-80.04Q220-758 274-758h40q18-38 51.57-60T440-840q49 0 85.5 32t47.5 85q23-27 49.6-41 26.61-14 56.4-14 51.07 0 86.53 35.66Q801-706.68 801-656v63Zm-320 60ZM324-180h312-312Z"
		/>
	</svg>
);
